module.exports = __webpack_public_path__ + "static/media/screen-projet2.fa4547a9.PNG";